import styled from "styled-components";

export const AppContainer = styled.div`
  max-width: 1280px;
  width: 100%;
  margin: auto;
`;
